<header class="site-header sticky-top py-1">
  <div>
    <app-main-nav></app-main-nav>
  </div>
</header>

<main>
  <div class="container">
    <div class="app-container">
      <div class="row">
        @if (showAccountNav) {
          <div class="col-sm-2 pt-4">
            <app-shop-nav></app-shop-nav>
          </div>
        }

        <div [class]="showAccountNav ? 'col-sm-10' : 'col-sm-12'">
          <div class="pt-4 mx-auto">
            @if (profileLoading && !profileSettled) {
              <div class="profile-loading">
                <app-loading-spinner i18n-text text="Profil wird geladen…"></app-loading-spinner>
              </div>
            } @else {
              @if (showLandingPage) {
                <div class="row">
                  <app-landing-page></app-landing-page>
                </div>
              }

              <app-breadcrumb></app-breadcrumb>

              <div class="row">
                <router-outlet></router-outlet>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <app-idle-timer></app-idle-timer>
  </div>
</main>

<div class="b-example-divider"></div>

<footer class="py-5">
  <app-footer></app-footer>
</footer>

<script src="../assets/dist/js/bootstrap.bundle.min.js"></script>
